import React from "react";
import { 
  MdBadge, 
  MdStars, 
  MdAccountBalance, 
  MdVerifiedUser, 
  MdGroups, 
  MdOutlineAccountTree, 
  MdWorkspacePremium,
  MdSchool
} from "react-icons/md";
import passport from "../assets/passport.jpg"; // Reference placeholder or actual asset path
import PageHero from "./PageHero";

export default function TeamContent() {
  
  // The 3 Founding Partners from the Company Profile Document
  const corporatePartners = [
    {
      name: "CPA Exvery Asheri",
      role: "Managing Partner & Auditor",
      tag: "Leading Tax Consultant",
      bio: "Spearheads day-to-day corporate stewardship, specializing in high-level tax engineering, corporate financial auditing, and strategic institutional advisory.",
      image: passport
    },
    {
      name: "CPA Dorcas G. Kimaro",
      role: "Partner & Registered Auditor",
      tag: "Board Management Partner",
      bio: "Directs statutory compliance audits and fiscal governance frameworks, ensuring perfect cross-border tracking and NBAA policy alignment.",
      image: passport
    },
    {
      name: "Edson Pantaleo Bilikundi",
      role: "Partner & Senior Tax Consultant",
      tag: "Tax Strategy Lead",
      bio: "Expert in complex tax dispute resolution, corporate asset restructuring, optimization frameworks, and custom tax advisory for businesses nationwide.",
      image: passport
    }
  ];

  const heroData = {
    kicker: "Expert Governance",
    title: "A Distinguished Alliance of Strategic Minds & Regulatory Advisors",
    description: "Meet the certified fiscal engineers, legal compliance experts, and corporate advisory leaders combining decades of localized East African insight to steer your organization toward sustainable operational growth."
  }

  // Management & Professional Support Staff
  const technicalStaff = [
    {
      name: "Alice Lugina Kondela",
      role: "Accountant & Administration Chief",
      badgeText: "Finance & Planning",
      summary: "Manages full-cycle corporate accounting, institutional financial reports, client portfolios, and continuous statutory reporting.",
      image: passport
    }
  ];

  // Real institutional compliance details mentioned in the profile
  const credentials = [
    { title: "Registered Certified Public Accountants", authority: "National Board of Accountants & Auditors (NBAA)", detail: "Active NBAA Member Firm Setup" },
    { title: "Full-Scale Public Practice Firm", authority: "Tax & Financial Consultancy Registry", detail: "Dar es Salaam & Dodoma Operations" },
    { title: "Continuous Professional Development", authority: "CPD Professional Training Alignment", detail: "Mandatory Weekly Friday Technical Briefings" }
  ];

  return (
    <div className="blessing-team-viewport">
      
      {/* PERFECTLY ALIGNED CENTERED HERO STRIP SECTION */}
      <PageHero data={heroData} />

      {/* CORE PARTNERS LEADERSHIP SECTION */}
      <section className="content-section founders-wrapper-spacing">
        <div className="container">
          <div className="section-heading text-center mb-5" data-aos="fade-up">
            <p className="section-kicker text-uppercase tracking-wider text-secondary">The Board</p>
            <h2 className="text-primary font-weight-bold">Board of Management Partners</h2>
            <div className="kicker-line mx-auto" />
            <p className="text-muted max-w-600 mx-auto mt-3">
              Founded by three experienced practicing partners to deliver high-quality business, 
              financial, and tax advisory services across Tanzania.
            </p>
          </div>

          <div className="founders-flex-row justify-content-center">
            {corporatePartners.map((partner, idx) => (
              <div className="one-person-founder-card" key={idx} data-aos="fade-up" data-aos-delay={idx * 100}>
                {/* Custom Badge Stamp */}
                <div className="one-person-badge-stamp">
                  <MdStars className="me-1" /> {partner.tag}
                </div>
                
                <div className="founder-image-frame">
                  <img src={partner.image} alt={partner.name} className="founder-passport-img" />
                </div>
                
                <div className="founder-info-details text-center">
                  <h3>{partner.name}</h3>
                  <span className="founder-role-title text-secondary">{partner.role}</span>
                  <p className="founder-bio-text">{partner.bio}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* PROFESSIONAL ACCOUNTING & MANAGEMENT STAFF SECTION */}
      <section className="content-section py-5 bg-light-surface-tint border-top border-bottom">
        <div className="container py-4">
          <div className="section-heading text-center mb-5" data-aos="fade-up">
            <p className="section-kicker text-uppercase text-secondary">Execution Excellence</p>
            <h2 className="text-primary font-weight-bold">Management &amp; Professional Staff</h2>
            <div className="kicker-line mx-auto" />
          </div>

          <div className="leadership-cards-grid row justify-content-center g-4">
            {technicalStaff.map((staff, index) => (
              <div className="col-lg-6" key={index} data-aos="zoom-in">
                <div className="premium-leader-badge-card h-100">
                  <div className="leader-badge-header">
                    <span className="badge-design-pill">
                      <MdBadge className="me-1 text-secondary" /> {staff.badgeText}
                    </span>
                  </div>
                  <div className="leader-card-body-layout">
                    <div className="leader-avatar-wrapper">
                      <img src={staff.image} alt={staff.name} className="leader-passport-photo" />
                    </div>
                    <div className="leader-text-content">
                      <h3>{staff.name}</h3>
                      <div className="role-container mb-2">
                        <span className="role-badge">{staff.role}</span>
                      </div>
                      <p className="text-muted-narrative">{staff.summary}</p>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
          
          <div className="text-center mt-5" data-aos="fade-up">
            <p className="text-muted italic-text small-text">
              Supported by our dedicated team of Assistant Accountants, IT System Managers, and Compliance Interns working cohesively to sustain top-tier client output.
            </p>
          </div>
        </div>
      </section>

      {/* REAL ORGANIZATIONAL CHART (Matches profile layout tree chart exactly) */}
      <section className="content-section corporate-tree-bg text-white py-5">
        <div className="container py-4">
          <div className="section-heading text-center mb-5" data-aos="fade-up">
            <p className="section-kicker text-secondary text-uppercase">Firm Architecture</p>
            <h2 className="text-white">Our Management Framework</h2>
            <p className="text-light-opacity max-w-600 mx-auto mt-2">
              Structured operational streams designed to maximize efficiency, oversight, and statutory compliance.
            </p>
          </div>

          {/* DESKTOP HIERARCHY TREE */}
          <div className="tree-chart-responsive-wrapper d-none d-md-block" data-aos="fade-up">
            <div className="corporate-tree-root">
              
              {/* Root Tier */}
              <div className="tree-node level-1-node">
                <div className="node-icon-box"><MdAccountBalance /></div>
                <h4>Board of Management Partners</h4>
                <p>Strategic Executive Governance</p>
              </div>

              <div className="tree-vertical-line" />

              {/* Sub-tiers */}
              <div className="tree-branch-row">
                <div className="tree-left-arm" />
                <div className="tree-right-arm" />

                {/* Left Arm: Tax & Advisory */}
                <div className="tree-branch-container">
                  <div className="tree-node level-2-node">
                    <div className="node-icon-box"><MdVerifiedUser /></div>
                    <h4>Registered Tax Consultants</h4>
                    <p>Tax Engineering &amp; TRA Compliance</p>
                  </div>
                  <div className="tree-vertical-line-short" />
                  <div className="tree-node level-3-node">
                    <div className="node-icon-box"><MdOutlineAccountTree /></div>
                    <h4>Auditors &amp; Core Staff</h4>
                    <p>Field Evaluations &amp; Ledger Verifications</p>
                  </div>
                </div>

                {/* Right Arm: Finance & Planning */}
                <div className="tree-branch-container">
                  <div className="tree-node level-2-node">
                    <div className="node-icon-box"><MdGroups /></div>
                    <h4>Finance, Planning &amp; Admin</h4>
                    <p>Accounting Infrastructure &amp; Client Management</p>
                  </div>
                  <div className="tree-vertical-line-short" />
                  <div className="tree-node level-3-node">
                    <div className="node-icon-box"><MdOutlineAccountTree /></div>
                    <h4>IT Systems &amp; Assistant Staff</h4>
                    <p>Digital Registers &amp; Submissions Support</p>
                  </div>
                </div>

              </div>

            </div>
          </div>

          {/* MOBILE TIMELINE HIERARCHY */}
          <div className="mobile-tree-timeline-view d-block d-md-none">
            <div className="mobile-timeline-backline" />
            
            <div className="mobile-tree-node-card">
              <span className="mobile-tier-indicator tier-1-bg">Level 1</span>
              <h4>Board of Management Partners</h4>
              <p>Governing supervision directed by the main firm partners.</p>
            </div>

            <div className="mobile-tree-node-card">
              <span className="mobile-tier-indicator tier-2-bg">Level 2</span>
              <h4>Registered Tax Consultants &amp; Auditors</h4>
              <p>Processing complete corporate tax blueprints and reporting criteria.</p>
            </div>

            <div className="mobile-tree-node-card">
              <span className="mobile-tier-indicator tier-3-bg">Level 3</span>
              <h4>Finance, Planning, IT &amp; Support</h4>
              <p>Day-to-day bookkeeping, administrative handling, and platform management.</p>
            </div>
          </div>

        </div>
      </section>

      {/* NBAA STANDING & CPD COMPLIANCE SECTION */}
      <section className="content-section qualifications-pad-spacing py-5">
        <div className="container py-4">
          <div className="row align-items-center g-5">
            <div className="col-lg-5" data-aos="fade-right">
              <div className="d-flex align-items-center mb-3 text-secondary gap-2">
                <MdSchool className="fs-3" />
                <span className="text-uppercase font-weight-bold tracking-wider font-12">Capacity Building</span>
              </div>
              <h2 className="text-primary font-weight-bold">Strict NBAA Standards &amp; Continuous Professional Development</h2>
              <p className="text-muted-narrative mt-3">
                To guarantee state-of-the-art accuracy, our entire staff participates in mandatory technical discussion sessions every Friday morning. Every team member actively registers for and sits for national professional examinations under the National Board of Accountants and Auditors (NBAA).
              </p>
            </div>
            
            <div className="col-lg-7" data-aos="fade-left">
              <div className="qualifications-box-grid d-flex flex-column gap-3">
                {credentials.map((cred, cIdx) => (
                  <div className="qualification-badge-tile d-flex align-items-center p-3 border rounded bg-white" key={cIdx}>
                    <div className="tile-badge-icon-wrap me-3 text-secondary fs-2">
                      <MdWorkspacePremium />
                    </div>
                    <div className="tile-text-wrap">
                      <h4 className="text-primary font-16 font-weight-bold mb-1">{cred.title}</h4>
                      <span className="issuing-body-text text-muted small d-block mb-1">{cred.authority}</span>
                      <div className="badge bg-light text-primary border rounded px-2 py-1 font-11">{cred.detail}</div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

    </div>
  );
}
  